import { createApiReducers, createApiReducerInitialState } from '../../../Helpers/reducer'
import {
  SELECT_ACTION,
  GET_CISCO_CONFIG,
  UPDATE_CISCO_CONFIG,
  GET_TENANT_ACDS,
  GET_METADATA,
} from './ciscoConfig.constants'

const initialState = {
  selectedAction: null,
  ...createApiReducerInitialState('acdServers', []),
  ...createApiReducerInitialState('ciscoConfig', []),
  ...createApiReducerInitialState('updateConfig', []),
  ...createApiReducerInitialState('metadata', []),
}

export default (state = initialState, action) => {
  const reducers = {
    [SELECT_ACTION]: (state, action) => ({
      ...state,
      selectedAction: action.selectedAction,
    }),
    ...createApiReducers(GET_TENANT_ACDS, 'acdServers', []),
    ...createApiReducers(GET_CISCO_CONFIG, 'ciscoConfig', []),
    ...createApiReducers(UPDATE_CISCO_CONFIG, 'updateConfig', []),
    ...createApiReducers(GET_METADATA, 'metadata', []),
  }

  return reducers[action.type] ? reducers[action.type](state, action) : state
}
